import { userActions } from "../../actionTypes";

const initialState = {
	pages: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case userActions.FACEBOOK_PAGES_FETCHING: {
			return { ...state, fetching: true };
		}

		case userActions.FACEBOOK_PAGES_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				pages: action.payload,
			};
		}

		case userActions.FACEBOOK_PAGES_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
			return state;
	}
};

export default Reducer;
